export const ManuItems =[
    {
       title : "Home",
       urll : "/",
       cName : "nav-links",
       icon : "fa-solid fa-house fa-shake",
    },
    {
       title : "About",
       urll : "/about",
       cName : "nav-links",
       icon :"fa-solid fa-circle-info fa-shake",
    },
    {
       title : "Services",
       urll : "/services",
       cName : "nav-links",
       icon : "fa-solid fa-briefcase fa-shake",
    },
    {
       title : "Booking",
       urll : "/booking",
       cName : "nav-links",
       icon : "fa-solid fa-file fa-shake",
    },
    {
       title : "Contact",
       urll : "/contact",
       cName : "nav-links",
       icon : "fa-solid fa-address-book fa-shake",
    },
    {
       title : "Sing Up",
       
       cName : "nav-links-mobile",
      
    }
]


